import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../common/state';

import { ISearchButtonProps, SearchButton } from '../../../common/components/search_button';
import { makeSearch } from '../../state/search';

import { isNewbuildingGkButtonExperiment } from '../filters/ab/newbuilding_gk_button';
import { isCommercialToResidentialTransition } from '../../../utils/category';

export type TStateProps = Pick<
  ISearchButtonProps,
  | 'count'
  | 'loading'
  | 'nextQueryString'
  | 'userInput'
  | 'searchButtonVariants'
  | 'searchButtonLabelText'
  | 'fullReloadRequired'
  | 'nextURL'
>;
export type TDispatchProps = Pick<ISearchButtonProps, 'onClick'>;
export type TOwnProps = Pick<
  ISearchButtonProps,
  'onClick' | 'theme' | 'searchButtonLabelText' | 'buttonStyle' | 'isNewAdvancedFilters' | 'isAdvancedFiltersOpened'
> & { isCountHidden?: boolean };

export const SearchButtonContainer = connect<TStateProps, TDispatchProps, TOwnProps, ISearchButtonProps>(
  (state: IAppState, ownProps: TOwnProps) => {
    const { filters, isRedesignEnabled, results } = state;

    const { jsonQuery: prevJsonQuery } = results;

    const {
      jsonQueryCount,
      jsonQuery: nextJsonQuery,
      jsonQueryCountRefresing,
      queryString,
      jsonQueryUrl,
      userInput,
    } = filters;

    const newbuildingGkButtonExperiment = isNewbuildingGkButtonExperiment(state);

    const searchButtonVariants: [string, string, string] = newbuildingGkButtonExperiment
      ? ['квартира', 'квартиры', 'квартир']
      : ['объект', 'объекта', 'объектов'];

    const searchButtonLabelText =
      ownProps.searchButtonLabelText || (newbuildingGkButtonExperiment ? 'Показать квартиры' : 'Показать объекты');

    return {
      count: jsonQueryCount,
      loading: jsonQueryCountRefresing,
      nextQueryString: queryString,
      nextURL: jsonQueryUrl,
      fullReloadRequired: isRedesignEnabled && isCommercialToResidentialTransition(nextJsonQuery, prevJsonQuery),
      userInput,
      searchButtonVariants,
      searchButtonLabelText,
    };
  },
  (dispatch: Dispatch) => ({
    onClick: () => dispatch(makeSearch()),
  }),
  (stateProps, dispatchProps, ownProps) => {
    const props = {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      theme: ownProps.theme,
      buttonStyle: ownProps.buttonStyle,
    };

    if (typeof ownProps.onClick === 'function') {
      props.onClick = ownProps.onClick;
    }

    if (ownProps.isCountHidden) {
      props.count = undefined;
    }

    return props;
  },
)(SearchButton);
